import apiClient from "./apiClient";

const BASE_URL = `${process.env.VUE_APP_BASE_URL as string}/api/v1/lms-log`;

export interface LmsRequestLogSearchParams {
  page: number;
  pageSize: number;
  lmsName?: string | null;
  username?: string | null;
  status?: number | null;
  accountingMonth?: number | null;
  accountingYear?: number | null;
  from?: string | null;
  to?: string | null;
  onlyErrors?: boolean | null;
}

export interface LmsRequestLogEntry {
  id: number;
  occurredAt: string;
  requestId: string | null;
  userId: string | null;
  username: string | null;
  lmsName: string | null;
  ip: string | null;
  method: string;
  path: string;
  queryString: string | null;
  accountingMonth: number | null;
  accountingYear: number | null;
  timesheetType: number | null;
  fileName: string | null;
  fileSize: number | null;
  storedPath: string | null;
  status: number;
  responseBody: string | null;
  durationMs: number | null;
  expectedCount: number | null;
  /** Садик из файла: при ошибке — запись, на которой упали; при успехе — если садик в файле один. */
  bin: string | null;
  lmsId: string | null;
}

/** Запись + сводка обработки из очереди (сколько садиков ушло, сохранено, рассчитано, с ошибками). */
export interface LmsRequestLogRow {
  entry: LmsRequestLogEntry;
  expectedCount: number | null;
  uploadOk: number;
  uploadError: number;
  calculationOk: number;
  calculationError: number;
  /** Сколько разных садиков прошло через очередь по этому обращению. */
  kindergartenCount: number;
  /** Регион (КАТО): садика записи либо общий для всех садиков файла; null, если регионов несколько или нет. */
  region: string | null;
  regionCount: number;
}

export interface LmsRequestResult {
  id: number;
  occurredAt: string;
  lmsId: string | null;
  stage: "UPLOAD" | "CALCULATION";
  status: "OK" | "ERROR";
  message: string | null;
}

/** Итог по садику + БИН и регион садика из справочника. */
export interface LmsRequestResultRow {
  result: LmsRequestResult;
  bin: string | null;
  region: string | null;
}

export async function findLmsRequestLog(params: LmsRequestLogSearchParams): Promise<{ totalElements: number; content: LmsRequestLogRow[] }> {
  const response = await apiClient.post(`${BASE_URL}/list`, params);
  return response.data;
}

export async function findLmsRequestResults(id: number): Promise<LmsRequestResultRow[]> {
  const response = await apiClient.get(`${BASE_URL}/${id}/results`);
  return response.data;
}

export async function downloadLmsFile(entry: LmsRequestLogEntry): Promise<void> {
  const response = await apiClient.get(`${BASE_URL}/${entry.id}/file`, { responseType: "blob" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(new Blob([response.data]));
  link.download = entry.storedPath ? entry.storedPath.split("/").pop() as string : (entry.fileName ?? `lms-${entry.id}`);
  link.click();
  window.URL.revokeObjectURL(link.href);
}
